/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import _findIndex from 'lodash/findIndex';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

export default (set, get, sku) => set(
  produce(
    get(),
    (draft) => {
      const updateExisting = _findIndex(get().design.cart, ['Sku', sku]);

      if (!draft.design) {
        draft.design = {};
      }

      if (updateExisting !== -1) {

        if (draft.design.cart[updateExisting].Quantity === 1) {
          draft.design.cart = draft.design.cart.filter(({ Sku }) => Sku !== sku);
        } else {
          draft.design.cart[updateExisting].Quantity -= 1;
        }
      }

      if (draft.design.cart.length < 1) {
        draft.design.hasAccessories = false;
      }
      draft.design.selectedProduct = null;

      // logging
      logNewRelicCustom(NEW_RELIC_EVENTS.NON_VISUALIZED_PRODUCT_REMOVED, get().design.cart);
    }),
  false,
  { type: 'ADD', payload: {} }
);
